/**
 * Gets the currency symbol for a given currency code using Intl.NumberFormat
 * This handles multi-character symbols (like "CA$", "R$") correctly
 */
export const getCurrencySymbol = (currencyCode: string): string => {
  try {
    const formatter = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currencyCode.toUpperCase(),
      currencyDisplay: 'narrowSymbol',
    });

    const parts = formatter.formatToParts(0);
    const currencyPart = parts.find((part) => part.type === 'currency');
    return currencyPart?.value || '$'; // Fallback to $ if something goes wrong
  } catch (error) {
    console.error(`Error getting currency symbol for ${currencyCode}:`, error);
    return '$'; // Fallback to $ if the currency code is invalid
  }
};
